import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NavBar from "../NavBar/NavBar.tsx";
import Footer from "../Footer/Footer.tsx";
import {
  serviceBannerImg,
  serviceBannerImg1,
  serviceBannerImg2,
  productbanner,
  PortfolioBanner,
  aboutUsImg1,
} from "../../Assets.tsx";

/* Colours: text #4e5356 | buttons #2596be | headings #4573a6 | background white
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body) */

// Hero image (swap for productbanner, PortfolioBanner or aboutUsImg1 if you prefer)
const HERO_IMG = serviceBannerImg;

// Data for all the cards
const cardData = [
  {
    title: "Website Development Services by Digiunix.ai",
    subtitle: "Fast, Responsive & Conversion-Optimized Websites",
    imageUrl: serviceBannerImg1,
    linkUrl: "/Blog-page1",
  },
  {
    title: "The Ultimate Guide to Google Ads, Meta Ads, and Bing Ads for 2025 - Boost Your ROI with Digiunix.ai",
    subtitle: "Digital Marketing",
    imageUrl: productbanner,
    linkUrl: "/Blog-page2",
  },
  {
    title: "Social Media Management Services by Digiunix.ai",
    subtitle: "Your End-to-End Solution for Growth",
    imageUrl: PortfolioBanner,
    linkUrl: "/Blog-page3",
  },
  {
    title: "SEO Solutions by DigiUnix.ai",
    subtitle: "Unlock Page-1 Rankings and Lead-Generating SEO Results",
    imageUrl: serviceBannerImg2,
    linkUrl: "/Blog-page4",
  },
  {
    title: "Analytics & Reporting Services by Digiunix.ai",
    subtitle: "Powerful Data Insights for Your Business",
    imageUrl: aboutUsImg1,
    linkUrl: "/Blog-page5",
  },
  {
    title: "The Ultimate Guide to Google Ads, Meta Ads, and Bing Ads for 2025 - Boost Your ROI with Digiunix.ai",
    subtitle: "Digital Marketing",
    imageUrl: serviceBannerImg,
    linkUrl: "/Blog-page6",
  },
];

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.bg{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;background:#fff;font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text)}
.bg-wrap{max-width:1240px;margin:0 auto;padding:0 24px}

.bg-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase}
.bg h1,.bg h2{margin:0 0 16px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:var(--head);cursor:default;transition:color .35s,letter-spacing .35s}
.bg h1:hover,.bg h2:hover{color:var(--btn);letter-spacing:.6px}
.bg-line{display:flex;align-items:center;gap:12px;margin-bottom:20px}
.bg-line i{display:block;height:2px;width:40px;border-radius:2px;background:var(--btn)}.bg-line i:last-child{background:var(--head)}
.bg p{margin:0 0 16px;font-size:14.5px;line-height:1.75;color:var(--text)}

.rv{opacity:0;transform:translateY(46px);transition:opacity .8s cubic-bezier(.2,.8,.2,1),transform .8s cubic-bezier(.2,.8,.2,1);transition-delay:var(--d,0s)}
.rv.in{opacity:1;transform:none}

/* button = same as .op-btn */
.bg-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:8px;padding:11px 24px;border:none;border-radius:50px;
  background:var(--tint);color:var(--head);font-family:"Open Sans",sans-serif;font-weight:600;font-size:14px;cursor:pointer;text-decoration:none;
  box-shadow:0 0 0 1px var(--line) inset;transition:color .35s,box-shadow .35s}
.bg-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.bg-btn span{display:inline-block;transition:transform .35s}
.bg-card:hover .bg-btn,.bg-feat:hover .bg-btn,.bg-btn:hover{color:#fff}
.bg-card:hover .bg-btn::before,.bg-feat:hover .bg-btn::before,.bg-btn:hover::before{transform:none}
.bg-btn:hover span{transform:translateX(5px)}

/* ---------- HERO ---------- */
.bg-hero{display:flex;align-items:center;justify-content:space-between;gap:60px;padding:150px 0 70px}
.bg-text{flex:1;min-width:0;max-width:580px;animation:bgL .9s cubic-bezier(.2,.8,.2,1) backwards}
.bg-vis{position:relative;flex:none;width:46%;max-width:540px;animation:bgR .9s .15s cubic-bezier(.2,.8,.2,1) backwards}
.bg-ring{position:absolute;inset:-14px;border-radius:44px;overflow:hidden}
.bg-ring::before{content:"";position:absolute;left:50%;top:50%;width:200%;height:200%;margin:-100% 0 0 -100%;
  background:conic-gradient(from 0deg,#4573a6,#2596be,#a9d3e6,#4573a6);animation:bgSpin 8s linear infinite}
.bg-ring::after{content:"";position:absolute;inset:4px;border-radius:40px;background:#fff}
.bg-tilt{position:relative;overflow:hidden;border-radius:32px;background:#fff;border:1px solid var(--line);box-shadow:0 30px 50px -26px rgba(69,115,166,.5);
  transition:transform .15s ease-out;transform:perspective(900px) rotateX(0) rotateY(0)}
.bg-tilt img{display:block;width:100%;height:auto;max-height:380px;object-fit:contain;padding:24px;box-sizing:border-box}
.bg-chipf{position:absolute;z-index:3;display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:16px;background:#fff;
  border:1px solid var(--line);box-shadow:0 18px 30px -16px rgba(69,115,166,.55);font-size:13px;color:var(--text);white-space:nowrap}
.bg-chipf b{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:15px;color:var(--head)}
.bg-chipf .dot{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;background:linear-gradient(135deg,var(--head),var(--btn))}
.bg-chipf.c1{left:-34px;bottom:44px;animation:bgFloat 5s ease-in-out infinite}
.bg-chipf.c2{right:-24px;top:34px;animation:bgFloat 6s -2s ease-in-out infinite}
.bg-tags{display:flex;flex-wrap:wrap;gap:10px;margin-top:6px}
.bg-tag{position:relative;overflow:hidden;z-index:0;padding:7px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);color:var(--head);
  font-size:14px;font-weight:600;cursor:default;transition:color .35s,border-color .35s,transform .35s cubic-bezier(.3,1.6,.5,1)}
.bg-tag::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateY(101%);transition:transform .4s cubic-bezier(.2,.8,.2,1)}
.bg-tag:hover{color:#fff;border-color:transparent;transform:translateY(-3px)}
.bg-tag:hover::before{transform:none}

/* ---------- LIST ---------- */
.bg-sec{text-align:center;padding:40px 0 100px}
.bg-sub{display:flex;align-items:center;justify-content:center;gap:12px;margin-bottom:34px}
.bg-sub i{display:block;height:2px;width:40px;border-radius:2px;background:var(--btn)}.bg-sub i:last-child{background:var(--head)}
.bg-sub p{margin:0}

/* search */
.bg-search{position:relative;max-width:460px;margin:0 auto 50px}
.bg-search svg{position:absolute;left:20px;top:50%;width:18px;height:18px;transform:translateY(-50%);fill:none;stroke:var(--head);stroke-width:2;stroke-linecap:round;pointer-events:none}
.bg-search input{width:100%;box-sizing:border-box;padding:14px 22px 14px 50px;border-radius:50px;border:1px solid var(--line);background:#fff;outline:none;
  font-family:"Open Sans",sans-serif;font-size:14.5px;color:var(--text);box-shadow:0 18px 36px -28px rgba(69,115,166,.55);transition:border-color .3s,box-shadow .3s}
.bg-search input::placeholder{color:#8a9296}
.bg-search input:focus{border-color:var(--btn);box-shadow:0 0 0 4px rgba(37,150,190,.12)}

/* post link wrapper */
.bg-a{display:flex;text-decoration:none;color:inherit;text-align:left;min-width:0}

/* media tile (illustration on tint) */
.bg-media{position:relative;display:flex;align-items:center;justify-content:center;height:150px;border-radius:16px;background:var(--tint);overflow:hidden;
  transition:background .4s}
.bg-media img{width:100%;height:100%;object-fit:contain;padding:10px;box-sizing:border-box;transition:transform .5s cubic-bezier(.3,1.4,.5,1)}

/* grid + card */
.bg-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:20px;align-items:stretch}
.bg-grid>.rv{display:flex;min-width:0}
.bg-grid>.rv>.bg-a{flex:1}
.bg-card{--mx:50%;--my:50%;--rx:0deg;--ry:0deg;position:relative;overflow:hidden;flex:1;min-width:0;display:flex;flex-direction:column;padding:12px 12px 20px;border-radius:20px;
  background:#fff;border:1px solid var(--line);box-shadow:0 14px 28px -22px rgba(69,115,166,.55);
  transform:perspective(900px) rotateX(var(--rx)) rotateY(var(--ry));transition:transform .18s ease-out,box-shadow .4s,border-color .4s}
.bg-card:hover{border-color:transparent;box-shadow:0 30px 50px -22px rgba(37,150,190,.7)}
.bg-glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;
  background:radial-gradient(240px circle at var(--mx) var(--my),rgba(37,150,190,.16),rgba(69,115,166,.05) 45%,transparent 70%)}
.bg-card:hover .bg-glow{opacity:1}
.bg-top{position:absolute;top:0;left:0;width:100%;height:5px;z-index:2;transform:scaleX(0);transform-origin:left;background:linear-gradient(90deg,var(--head),var(--btn));transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.bg-card:hover .bg-top,.bg-feat:hover .bg-top{transform:scaleX(1)}
.bg-num{position:absolute;top:16px;right:20px;z-index:1;font-size:38px;font-weight:800;line-height:1;pointer-events:none;color:transparent;-webkit-text-stroke:1.5px rgba(69,115,166,.28);
  transition:transform .5s cubic-bezier(.2,.8,.2,1),-webkit-text-stroke-color .4s}
.bg-card:hover .bg-num{transform:translate(4px,-4px);-webkit-text-stroke-color:rgba(37,150,190,.6)}
.bg-card:hover .bg-media,.bg-feat:hover .bg-media{background:#fff;box-shadow:inset 0 0 0 1px var(--line)}
.bg-card:hover .bg-media img,.bg-feat:hover .bg-media img{transform:scale(1.06)}
.bg-body{position:relative;display:flex;flex-direction:column;flex:1;padding:16px 6px 0}
.bg-label{align-self:flex-start;max-width:100%;margin-bottom:10px;padding:4px 12px;border-radius:50px;background:var(--tint);border:1px solid var(--line);
  color:var(--head);font-size:11px;letter-spacing:1px;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.bg-card h3{margin:0 0 16px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:17px;line-height:1.35;letter-spacing:.4px;color:var(--head);
  display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;transition:color .35s}
.bg-card:hover h3{color:var(--btn)}
.bg-card .bg-btn{align-self:flex-start;margin-top:auto;padding:9px 20px;font-size:13px}

/* featured */
.bg-feat{position:relative;overflow:hidden;flex:1;min-width:0;display:flex;align-items:center;gap:36px;margin-bottom:20px;padding:18px 36px 18px 18px;border-radius:28px;
  background:#fff;border:1px solid var(--line);box-shadow:0 30px 50px -30px rgba(69,115,166,.55);text-align:left;
  transition:transform .4s cubic-bezier(.3,1.4,.5,1),box-shadow .4s,border-color .4s}
.bg-feat:hover{transform:translateY(-8px);border-color:rgba(37,150,190,.5);box-shadow:0 30px 50px -22px rgba(37,150,190,.6)}
.bg-feat .bg-media{flex:none;width:40%;height:220px;border-radius:18px}
.bg-feat .bg-media img{padding:14px}
.bg-feat-txt{flex:1;min-width:0}
.bg-feat .bg-label{display:inline-block}
.bg-feat h2{font-size:26px;margin:0 0 10px}
.bg-feat:hover h2{color:var(--btn)}
.bg-feat p{margin:0 0 20px}

.bg-empty{padding:40px 0;font-size:15px}

@keyframes bgL{from{opacity:0;transform:translateX(-70px)}}
@keyframes bgR{from{opacity:0;transform:translateX(70px)}}
@keyframes bgSpin{to{transform:rotate(360deg)}}
@keyframes bgFloat{50%{transform:translateY(-12px)}}

@media(max-width:1000px){.bg-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
@media(max-width:960px){
  .bg-hero{flex-direction:column;gap:64px;padding:120px 0 50px}
  .bg-text{max-width:100%}
  .bg-vis{width:100%;max-width:440px}
  .bg-chipf.c1{left:-8px}.bg-chipf.c2{right:-8px}
  .bg-feat{flex-direction:column;align-items:stretch;gap:20px;padding:16px 16px 26px}
  .bg-feat .bg-media{width:100%;height:200px}
  .bg-feat-txt{padding:0 8px}
}
@media(max-width:600px){
  .bg h1,.bg h2{font-size:30px}.bg-feat h2{font-size:22px}
  .bg-grid{grid-template-columns:1fr}
  .bg-sub i{display:none}
}
@media(prefers-reduced-motion:reduce){
  .bg *,.bg *::before,.bg *::after{animation:none!important;transition:none!important}
  .rv{opacity:1;transform:none}
}
`;

/* fades a block in once it scrolls into view */
const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={"rv " + className + (show ? " in" : "")}
      style={{ "--d": delay + "s" }}
    >
      {children}
    </div>
  );
};

const PostCard = ({ post, index }) => {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    el.style.setProperty("--mx", x + "px");
    el.style.setProperty("--my", y + "px");
    el.style.setProperty("--ry", ((x / r.width - 0.5) * 6).toFixed(2) + "deg");
    el.style.setProperty("--rx", ((0.5 - y / r.height) * 6).toFixed(2) + "deg");
  };
  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.setProperty("--rx", "0deg");
    ref.current.style.setProperty("--ry", "0deg");
  };

  return (
    <Link to={post.linkUrl} className="bg-a">
      <div className="bg-card" ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave}>
        <div className="bg-top" />
        <div className="bg-glow" />
        <span className="bg-num">{String(index + 1).padStart(2, "0")}</span>
        <div className="bg-media">
          <img src={post.imageUrl} alt={post.title} loading="lazy" />
        </div>
        <div className="bg-body">
          <span className="bg-label" title={post.subtitle}>{post.subtitle}</span>
          <h3>{post.title}</h3>
          <span className="bg-btn">Read Article <span>→</span></span>
        </div>
      </div>
    </Link>
  );
};

const Blog = () => {
  const tiltRef = useRef(null);
  const [query, setQuery] = useState("");

  // gentle 3D tilt on the hero image
  const handleMove = (e) => {
    const el = tiltRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const handleLeave = () => {
    if (tiltRef.current) tiltRef.current.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
  };

  const q = query.trim().toLowerCase();
  const filtered = cardData.filter(
    (c) => c.title.toLowerCase().includes(q) || c.subtitle.toLowerCase().includes(q)
  );
  const showFeatured = q === "";
  const featured = cardData[0];
  const gridItems = showFeatured ? cardData.slice(1) : filtered;

  return (
    <div>
      <NavBar />
      <style>{STYLES}</style>

      <div className="bg">
        <div className="bg-wrap">
          {/* HERO */}
          <div className="bg-hero">
            <div className="bg-text">
              <div className="bg-chip">Our Blog</div>
              <h1>The Future of Digital Marketing: Trends and Insights</h1>
              <div className="bg-line"><i /><i /></div>
              <p>
                Explore how AI, automation, and data analytics are reshaping the industry and what it means
                for your business.
              </p>
              <div className="bg-tags">
                <span className="bg-tag">AI</span>
                <span className="bg-tag">Automation</span>
                <span className="bg-tag">Data Analytics</span>
              </div>
            </div>

            <div className="bg-vis" onMouseMove={handleMove} onMouseLeave={handleLeave}>
              <div className="bg-ring" />
              <div className="bg-tilt" ref={tiltRef}>
                <img src={HERO_IMG} alt="Digital marketing trends and insights" />
              </div>
              <div className="bg-chipf c1">
                <span className="dot">✓</span>
                <div>Fresh<b>Insights</b></div>
              </div>
              <div className="bg-chipf c2">
                <span className="dot">★</span>
                <div>Digital<b>Marketing</b></div>
              </div>
            </div>
          </div>

          {/* ARTICLES */}
          <div className="bg-sec">
            <div className="bg-chip">Latest Articles</div>
            <h2>Read Our Latest Posts</h2>
            <div className="bg-sub">
              <i />
              <p>Guides and services to help your business grow online.</p>
              <i />
            </div>

            <div className="bg-search">
              <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
              <input
                type="text"
                placeholder="Search articles..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                aria-label="Search articles"
              />
            </div>

            {showFeatured && (
              <Reveal>
                <Link to={featured.linkUrl} className="bg-a">
                  <div className="bg-feat">
                    <div className="bg-top" />
                    <div className="bg-media">
                      <img src={featured.imageUrl} alt={featured.title} />
                    </div>
                    <div className="bg-feat-txt">
                      <span className="bg-label">Featured</span>
                      <h2>{featured.title}</h2>
                      <p>{featured.subtitle}</p>
                      <span className="bg-btn">Read Article <span>→</span></span>
                    </div>
                  </div>
                </Link>
              </Reveal>
            )}

            {gridItems.length > 0 ? (
              <div className="bg-grid">
                {gridItems.map((post, i) => (
                  <Reveal key={post.linkUrl} delay={(i % 3) * 0.1}>
                    <PostCard post={post} index={showFeatured ? i + 1 : cardData.indexOf(post)} />
                  </Reveal>
                ))}
              </div>
            ) : (
              <p className="bg-empty">No articles match “{query}”. Try a different keyword.</p>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blog;